<div
    class="miles-editable miles-card padded"
    *ngIf="!isEditing && delivery.Id > 0"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    (click)="edit()"
    [style.cursor]="canEdit ? 'pointer' : 'default'"
>
    <h4>
        Delivery Info
        <span class="pull-right" *ngIf="canEdit" [hidden]="!isHovered">
            <i class="fa fa-lg fa-edit"></i>
        </span>
    </h4>
    <mt-dynamic-view [config]="viewOnly"></mt-dynamic-view>
</div>
<div *ngIf="isEditing" class="miles-form padded">
    <h4>Delivery Info</h4>
    <mt-dynamic-form [config]="formObject" (submitted)="formSubmitted($event)" (formCreated)="formCreated($event)">
        <div [hidden]="!showAdditionalContainers" class="extra-containers-section">
            <div *ngIf="showContainerNote" class="container-note">
                Note: Each container number entered will create a separate unique delivery number.
            </div>
            <div *ngFor="let num of additionalContainerNumbers; let i = index; trackBy: trackByIndex" class="extra-container-row">
                <div class="input-group" style="width: 100%; display: table; border-collapse: separate">
                    <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="additionalContainerNumbers[i]"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Enter container number"
                    />
                    <span class="input-group-btn">
                        <button
                            type="button"
                            class="btn btn-flat btn-danger extra-container-remove-btn"
                            (click)="removeContainerNumber(i)"
                            title="Remove"
                        >
                            <i class="fa fa-times"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <button type="submit" mtDisableClickDuringHttpCalls Class="btn btn-flat btn-success">Save</button>
        <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
    </mt-dynamic-form>
</div>
<div *ngIf="canAdd" class="fab-wrap-b-r">
    <a class="btn btn-primary btn-fab-lg" [routerLink]="['/deliveries', 'add']">
        <span class="fa fa-plus"></span>
    </a>
</div>
